import { translations } from './signup-field-translations';
import t from '@jetshop/intl';
export const getFieldType = (name) => {
    switch (name) {
        case 'mobilePhone':
            return 'tel';
        case 'emailAddress':
            return 'email';
        case 'password':
            return 'password';
        default:
            return 'text';
    }
};
export function formFieldsFromSettings(selectedCountrySettings, isUserTypeBusiness) {
    const customerFieldsKey = !isUserTypeBusiness
        ? 'privateCustomerFields'
        : 'businessCustomerFields';
    const billingAddress = selectedCountrySettings &&
        selectedCountrySettings[customerFieldsKey].find(field => field.name === 'billingAddress');
    const deliveryAddress = selectedCountrySettings &&
        selectedCountrySettings[customerFieldsKey].find(field => field.name === 'deliveryAddress');
    const billingAddressFields = billingAddress
        ? billingAddress.fields.map(field => (Object.assign(Object.assign({}, field), { label: translations[field.name], placeholder: `${translations[field.name]}_placeholder`, type: getFieldType(field.name) })))
        : [];
    const deliveryAddressFields = deliveryAddress
        ? deliveryAddress.fields.map(field => (Object.assign(Object.assign({}, field), { label: translations[field.name], placeholder: `${translations[field.name]}_placeholder`, type: getFieldType(field.name) })))
        : [];
    const emailField = selectedCountrySettings
        ? selectedCountrySettings[customerFieldsKey].find(field => field.name === 'emailAddress')
        : null;
    const passwordField = selectedCountrySettings
        ? selectedCountrySettings[customerFieldsKey].find(field => field.name === 'password')
        : null;
    const pid = selectedCountrySettings === null || selectedCountrySettings === void 0 ? void 0 : selectedCountrySettings[customerFieldsKey].find(field => field.name === 'pid' || field.name === 'organizationNumber');
    const pidField = Object.assign(Object.assign({}, pid), { type: 'text', id: 'pid', name: isUserTypeBusiness ? 'organizationNumber' : 'pid', label: isUserTypeBusiness
            ? translations['company_pid']
            : translations['pid'] });
    const loginFields = emailField && passwordField
        ? [
            Object.assign(Object.assign({}, emailField), { type: getFieldType('emailAddress'), id: 'emailAddress', name: 'emailAddress', label: translations['email'], placeholder: translations['email_placeholder'] }),
            Object.assign(Object.assign({}, passwordField), { type: getFieldType('password'), id: 'password', name: 'password', label: translations['password'], placeholder: translations['password_placeholder'] })
        ]
        : [];
    const allFields = [...billingAddressFields, ...loginFields, pidField];
    return {
        allFields,
        billingAddressFields,
        deliveryAddressFields,
        loginFields,
        pidField
    };
}
// Create validation based on the rules specified in the CustomerFields from
// channel settings
export function createValidatorForFields(fields, { getFieldName = (name) => name, getFieldValue = (values, fieldName) => values[fieldName], customValidation } = {}) {
    return function validate(values) {
        const errors = {};
        fields.forEach(field => {
            const pattern = field.pattern && new RegExp(unescape(field.pattern));
            const fieldName = getFieldName(field.name);
            const value = getFieldValue(values, fieldName);
            // make sure that pattern is actually a valid regex
            if (pattern && !pattern.test(value)) {
                errors[fieldName] = t('Field does not match required format');
            }
            if (field.required && !value) {
                errors[fieldName] = t('This field is required');
            }
            customValidation && customValidation(errors, values);
        });
        return errors;
    };
}
//# sourceMappingURL=formFieldsFromSettings.js.map